import { useMutation } from "react-query";
import { addLeasedEquipmentType } from "../../../../../actions/Utilities/LeasedEquipmentType";
import { toast } from "components/toastNotification";
import { IType } from "../types";

const useAddType = () => {
  const { mutate } = useMutation(
    (NewData: IType) => addLeasedEquipmentType(NewData),
    {
      onSuccess: (res: any) => {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Type Added Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Type Added Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire("Adding Type failed ", `Server Error: ${res}`, "error");
            break;
          case res == "The data already exists!":
            toast.fire(
              "Adding Type failed",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire("Adding Type failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Adding Type failed", res.Message, "error");
        }
      },

      onError: (error: any) => {
        toast.fire("Add Type failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddType;
